module.exports = __webpack_public_path__ + "img/chat_grey.a89fc34a.svg";